<template>
  <v-card class="mt-3 pa-3" style="margin: 15px">
    <form @submit.prevent="gerarRelatorio">
      <div>
        <Select
          label="Ano"
          :options="optionsAno"
          v-model.number="aaletivo"
          :v="$v.aaletivo"
          :disabled="loading"
        />
        <Select
          label="Turma"
          :options="optionsTurma"
          v-model="cdturma"
          :v="$v.cdturma"
          :disabled="loading"
        />
        <Select
          :label="(this.aaletivo >=2020 && this.tipoDeEnsino === 'I') ? 'Campos de Experiência' : 'Disciplina'"
          :options="optionsDisciplina"
          v-model.number="cddiscipl"
          :v="$v.cddiscipl"
          :disabled="loading"
        />
        <Select
          label="Tipo"
          :options="optionsTipo"
          v-model="tipo"
          :v="$v.tipo"
          :disabled="loading"
        />
        <Select
          v-if="tipo === 'A'"
          label="Período Avaliativo"
          :options="optionsPeriodo"
          v-model="cdpravadi"
          :v="$v.cdpravadi"
          :disabled="loading"
        />
      </div>

      <div style="text-align: right">
        <v-btn
          width="120px"
          class="rounded-sm font-weight-regular"
          type="submit"
          color="teal"
          style="color:white"
          :disabled="loading"
          :loading="loadingGerar"
        >
          <v-icon size="23" left dark>picture_as_pdf</v-icon>Gerar
        </v-btn>
      </div>
    </form>
  </v-card>
</template>

<script>
import { mapGetters } from "vuex";
import { required } from "vuelidate/lib/validators";
import { RepositoryFactory } from "@/repositories/RepositoryFactory";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import registroNotasAnaliticoReport from "@/reports/professor/registroNotasAnaliticoReport";
import registroNotasConsolidadoReport from "@/reports/professor/registroNotasConsolidadoReport";

const ProfReports = RepositoryFactory.get("professorReports");
const TurmasRepository = RepositoryFactory.get("turma");
const DisciplinaRepository = RepositoryFactory.get("disciplina");

pdfMake.vfs = pdfFonts.pdfMake.vfs;

const defaultSelect = () => ({
  text: "",
  value: ""
});

export default {
  name: "DemonstrativoNotas",
  data() {
    return {
      aaletivo: "",
      cdturma: "",
      cddiscipl: "",
      tipo: "A",
      cdpravadi: "",
      tipoDeEnsino:"",
      loading: false,
      loadingGerar: false,
      optionsTurma: [defaultSelect()],
      optionsDisciplina: [defaultSelect()],
      optionsPeriodo: [defaultSelect()],
      optionsTipo: [
        { text: "Analítico", value: "A" },
        { text: "Consolidado", value: "C" }
      ],
      form: {
        aaletivo: "",
        cdtipesc: "",
        cdescola: "",
        cdturma: "",
        cddiscipl: "",
        cdpravadi: "",
        cdpessoal: "",
        cdmatric: "",
        tipoDeEnsino: "",
      }
    };
  },
  validations() {
    return {
      aaletivo: { required },
      cdturma: { required },
      cddiscipl: { required },
      tipo: { required },
      cdpravadi: { required: this.tipo === "A" ? required : "" }
    };
  },
  async created() {
    this.aaletivo = this.getAnoAtualServidor;
    await this.loadTurma();
  },
  watch: {
    async aaletivo(newVal, oldVal) {
      this.cdturma = "";
      this.cddiscipl = "";
      this.cdpravadi = "";
      await this.loadTurma();
    },
    async cdturma(newVal, oldVal) {
      this.cddiscipl = "";
      this.cdpravadi = "todos";
      await this.loadDisciplinaPeriodo();
    },
    async tipo(newVal, oldVal) {
      this.cdpravadi = 'todos';
      this.$v.cdpravadi.$reset();
    }
  },
  methods: {
    async loadTurma() {
      if (this.aaletivo === "") {
        return;
      }
      try {
        this.loading = true;
        const { data } = await TurmasRepository.getSelectTurmasPerfil({
          ...this.userProfessor,
          ...this.school,
          aaletivo: this.aaletivo
        });
        const turmasRegulares = data.results.filter( e => e.cdtpatend === 0)
        this.optionsTurma = turmasRegulares.map(key => ({
          text: `${key.nmturma} - ${key.horario}`,
          value: key.cdturma,
          tipoDeEnsino: key.cntpensin,
        }));
        this.optionsTurma.unshift(defaultSelect());
      } finally {
        this.loading = false;
      }
    },
    async loadDisciplinaPeriodo() {
      if (this.cdturma === "") {
        return;
      }
      this.tipoDeEnsino = this.optionsTurma[this.optionsTurma.findIndex(element => element.value === this.cdturma)].tipoDeEnsino;
      try {
        this.loading = true;
        const {
          data
        } = await DisciplinaRepository.getSelectDisciplinaPerfilPeriodo({
          ...this.userProfessor,
          ...this.school,
          aaletivo: this.aaletivo,
          cdturma: this.cdturma
        });

        this.optionsDisciplina = data.results.disciplinas.map(key => ({
          text: key.dsdiscipl,
          value: key.cddiscipl
        }));
        this.optionsPeriodo = data.results.periodos.map(key => ({
          text: key.dspravadi,
          value: key.cdpravadi
        }));
        this.optionsDisciplina.unshift(defaultSelect());
        this.optionsPeriodo.unshift({
          text: "Todos",
          value: "todos"
        });
        this.optionsPeriodo.unshift(defaultSelect());

      } finally {
        this.loading = false;
      }
    },
    async gerarRelatorio() {
      this.loadingGerar = true;
      try{
        const test = this.optionsTurma.find(key => key.value === this.cdturma);
        const filtros = {
          nmescola: this.school.nmescola,
          aaletivo: this.aaletivo,
          turma: this.optionsTurma.find(key => key.value === this.cdturma).text,
          disciplina: this.optionsDisciplina.find(
            key => key.value === this.cddiscipl
          ).text,
          periodo: this.optionsPeriodo.find(key => key.value === this.cdpravadi)
            .text,
          nomeProfessor: this.username // buscar da query
        };


        this.form.aaletivo = this.aaletivo;
        this.form.cdtipesc = this.school.cdtipesc;
        this.form.cdescola = this.school.cdescola;
        this.form.cdturma = this.cdturma;
        this.form.cddiscipl = this.cddiscipl;
        this.form.cdpravadi = this.cdpravadi;
        this.form.cdpessoal = this.userProfessor.cdpessoal;
        this.form.cdmatric = this.userProfessor.cdmatric;
        this.form.tipoDeEnsino = this.tipoDeEnsino;

        if(this.tipo == "A"){
          const { data } = await ProfReports.getDemonstrativoNotasAnalitico(this.form);

          const docDefinition = await registroNotasAnaliticoReport({
            date: data.results.date,
            time: data.results.time,
            filtros,
            cdpravadi: this.cdpravadi,
            data: data.results,
            professores: data.results.professores,
            tipoDeEnsino: this.tipoDeEnsino,
            indicaanoletivoexcedeu: data.results.configuracao_ano_letivo.indicaanoletivoexcedeu,
            anoSubsequente: data.results.configuracao_ano_letivo.fim.substring(0,4), // 2021
          });
          pdfMake.createPdf(docDefinition).download(docDefinition.info.title);

        }else if( this.tipo == "C"){
          const { data } = await ProfReports.getDemonstrativoNotasConsolidado(this.form);

          const docDefinition = await registroNotasConsolidadoReport({
            date: data.results.date,
            time: data.results.time,
            filtros,
            data: data.results,
            professores: data.results.professores,
            tipoDeEnsino: this.tipoDeEnsino,
            indicaanoletivoexcedeu: data.results.configuracao_ano_letivo.indicaanoletivoexcedeu,
            anoSubsequente: data.results.configuracao_ano_letivo.fim.substring(0,4), // 2021
          });
          pdfMake.createPdf(docDefinition).download(docDefinition.info.title);
        }

      }finally{
        this.loadingGerar = false;
      }
    }
  },
  computed: {
    ...mapGetters([
      "getAnoSistema",
      "getAnoAtualServidor",
      "getAnoInicioSistema",
      "userProfessor",
      "school",
      "username"
    ]),
    optionsAno() {
      if (!this.getAnoInicioSistema || !this.getAnoAtualServidor) {
        return [];
      }
      let retornoOptions = [defaultSelect()];
      for (
        let i = this.getAnoAtualServidor;
        i >= this.getAnoInicioSistema;
        i--
      ) {
        retornoOptions.push({ text: i, value: i });
      }
      return retornoOptions;
    }
  }
};
</script>

<style>
</style>
